module.exports = __webpack_public_path__ + "static/media/reddit.440605de.svg";